import './LanguageAndCurrencySwitch.scss';

import { Capacitor } from '@capacitor/core';
import { getCurrencyCode, getCurrencyLabel, useConfig } from '@travelwin/core';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { useOutlet } from 'react-router';

import CurrencySelector from '../../../components/CurrencySelector';
import { LanguageSwitch } from '../../../components/Navbar/GlobalPreferencePanel';
import { useCurrency } from '../../../context/Currency';
import { useLocaleUtils } from '../../../hooks/useLocaleUtils';

const className = 'c-LanguageAndCurrencySwitch';

const LanguageAndCurrencySwitch = () => {
  const { t } = useTranslation();
  const { currentLocale, supportedLocales } = useLocaleUtils();
  const { PAYMENT_SUPPORTED_CURRENCIES, PAYMENT_DEFAULT_CURRENCY } =
    useConfig();
  const { currency, setCurrency } = useCurrency();
  const isNative = Capacitor.isNativePlatform();
  const hasOutlet = useOutlet();

  const selectedCurrency = PAYMENT_SUPPORTED_CURRENCIES?.length
    ? currency ?? PAYMENT_DEFAULT_CURRENCY ?? PAYMENT_SUPPORTED_CURRENCIES[0]
    : undefined;
  const showCurrencySelector = isNative && !!selectedCurrency;
  const showLanguageSwitch =
    isNative && supportedLocales.length > 1 && !hasOutlet;

  return showLanguageSwitch ? (
    <div className={className}>
      <div
        className={classNames(`${className}__language-switch`, {
          [`${className}__language-switch--display`]: showLanguageSwitch,
          [`${className}__language-switch--hide`]: !showLanguageSwitch,
        })}
      >
        <label
          htmlFor="language-switch"
          className={`${className}__language-switch-label`}
        >
          {t('language.label', 'Language')}
        </label>
        <LanguageSwitch id="language-switch" variant="full" />
        {showCurrencySelector ? (
          <CurrencySelector
            onChange={setCurrency}
            value={selectedCurrency}
            rootClassName={`${className}__currency-switch`}
          >
            <CurrencySelector.Trigger>
              <CurrencySelector.Selected>
                {getCurrencyCode(currentLocale, selectedCurrency)}
              </CurrencySelector.Selected>
            </CurrencySelector.Trigger>
            <CurrencySelector.Choices>
              {PAYMENT_SUPPORTED_CURRENCIES?.map((choice) => (
                <CurrencySelector.Choice value={choice} key={choice}>
                  {getCurrencyLabel(currentLocale, choice)}
                </CurrencySelector.Choice>
              ))}
            </CurrencySelector.Choices>
          </CurrencySelector>
        ) : null}
      </div>
    </div>
  ) : null;
};

export default LanguageAndCurrencySwitch;
